<template>
  <b-nav
    vertical
    class="sub-menu"
  >
    <b-nav-item
      :id="`navItem-${id}`"
      class="selector sub-menu-title"
      :aria-controls="`statusCollapse-${id}`"
      :aria-expanded="visible ? 'true' : 'false'"
      @click="toggle"
    >
      <div class="icon-wrapper icon-color">
        <slot name="icon">
          <fa-icon
            v-if="icon"
            fixed-width
            :icon="icon"
          />
          <i
            v-if="alticon"
            :class="alticon"
            aria-hidden="true"
          />
          <i
            v-if="iconClass"
            :class="iconClass"
            class="iconClass"
            aria-hidden="true"
          />
        </slot>
      </div>
      <span>{{ title }}</span>
      <fa-icon
        class="arrow-menu mr-2"
        :icon="chevron"
      />
    </b-nav-item>
    <b-collapse
      :id="`statusCollapse-${id}`"
      v-model="visible"
    >
      <b-nav
        class="sub-menu-items"
        vertical
      >
        <slot />
      </b-nav>
    </b-collapse>
  </b-nav>
</template>

<script>

export default {
    name: 'SubMenu',
    props: {
        id: { type: String, required: true },
        title: { type: String, required: true },
        icon: { type: [Array, String] },
        iconClass: { type: String },
        alticon: { type: String }
    },
    data() {
        return {
            visible: true
        }
    },
    computed: {
        chevron() {
            return this.visible ? ['fal', 'chevron-up'] : ['fal', 'chevron-down']
        }
    },
    methods: {
        toggle() {
            this.visible = !this.visible
        }
    }
}

</script>

<style scoped lang="scss">

.iconClass {
  color: white
}

.arrow-menu{
  font-size: 0.7rem;
}

.selector:hover{
  background: vt-color(sidebar-parent-bg-hover);
}

.icon-wrapper {
  font-size: 1rem;
  margin-right: 7px;
  width: 32px;
  color: vt-color(sidebar-parent-font);
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;

  > .svg-inline--fa {
    margin-left: unset !important;
  }
}

.sub-menu-title {
  font-weight: bold;
  svg:last-child { // the chevron
    margin-left: auto;
  }
  .nav-link:hover {
    color: vt-color(primary);
  }
  .nav-link {
    padding: {
      right: .5rem;
      left: .5rem;
      top: 0.1rem;
      bottom: 0.1rem;
    }
  }
}

.sub-menu-title span{
  color: vt-color(sidebar-parent-font);
}

.sub-menu-items {
    ::v-deep .nav-link {
    position: relative;
    &:hover {
      background-color: vt-color(sidebar-submenu-bg-hover);
    }
    &.active {
      color: vt-color(white-light) !important;
      background: vt-color(primary) !important;
      &::before {
        content: "";
        position: absolute;
        height: 100%;
        width: 3px;
        left: -7px;
        background-color: vt-color(black);
      }
    }
  }
}

.sub-menu-items{
  background:vt-color(sidebar-childs-bg);
}

.nav-link span{
    font-size: 0.9rem;
  }

@media (max-width: 1300px){
  .nav-link span{
    font-size: 0.9rem;
  }

  .icon-wrapper{
    font-size: 1.1rem;
  }

}

</style>
